<template>
<v-menu offset-y  >
    <v-btn icon slot="activator"><v-icon>more_vert</v-icon></v-btn>
    <v-list>
        <v-list-tile ><v-list-tile-title>Generate Invoice</v-list-tile-title></v-list-tile>
    </v-list>
</v-menu>
</template>

<script>
export default {

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// ClientActionMenu.vue?14c98f0a